import styled from 'styled-components'
import { TransparentButton } from 'components/common/common_styles'
import { sizeTiny } from 'components/globalStyles'

export const InfoButton = styled(TransparentButton)`
  position: relative;
  margin-left: 4px;
  flex: none;
  height: fit-content;

  & img {
    max-width: none;
  }
`

export const InfoPopup = styled.div`
  background: var(--spBlack);
  color: white;
  padding: 12px 16px;
  display: none;
  position: absolute;
  font-family: Proxima;
  font-weight: normal;
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0;
  text-transform: none;
  text-align: left;
  white-space: normal;
  width: max-content;
  max-width: 300px;
  left: 0;
  top: 0;
  z-index: 2;
  transform: translate(${props => props.offset}px, 23px);

  ${InfoButton}:hover & {
    display: inherit;
  }

  @media (max-width: ${sizeTiny}) {
    max-width: 260px;
  }
`

export const InfoArrow = styled.svg`
  position: absolute;
  left: 50%;
  bottom: 0;
  fill: var(--spBlack);
  transform: translate(-50%, 8px);
  display: none;

  ${InfoButton}:hover & {
    display: inherit;
  }
`
